import { HealthcareProviderRegisterBookNumber } from '@dreryk/healthcare-provider-register-book-number-api';

import { useTranslate } from '@dreryk/react-common';
import { ClassNameProp, TextView } from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../translations';

type RegisterBookNumberTextViewProps = ClassNameProp & {
   readonly value: HealthcareProviderRegisterBookNumber | undefined | null;
};

export const RegisterBookNumberTextView = (props: RegisterBookNumberTextViewProps): JSX.Element => {
   const translate = useTranslate();
   return (
      <TextView
         label={healthcareProviderTranslationKeys.registerBookNumber}
         testId={'registerBookNumber'}
         className={props.className}
      >
         {props.value?.asString() ?? translate(healthcareProviderTranslationKeys.noData)}
      </TextView>
   );
};
